import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import FindRepForm from './FindRepForm';
import {
    AnimationContainer,
    Container as BaseContainer,
    Body as BaseBody
} from '../Shared/PopupModalStyles';

const Container = styled(BaseContainer)`
    width: 100;

    @media (max-width: 30em) {
        width: 100%;
    }
`;

const Body = styled(BaseBody)`
    padding: 25px 20px;
`;

const Message = styled.span`
    font-size: 14px;
    font-family: Lato;
`;

const FindLocalRepPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                {props.message && <Message>{props.message}</Message>}
                <FindRepForm
                    noBack={props.noBack}
                    isDoubleCheckRepPopup={props.isDoubleCheckRepPopup}
                    address={props.address}
                    submitting={props.submitting}
                    onBack={props.hideFindRepPopup}
                    handleSubmit={event => {
                        event.preventDefault();
                        props
                            .onSubmit(props.address)
                            .then(() => {
                                if (typeof props.callback === 'function')
                                    props.callback();
                            })
                            .catch(() => console.log('Representatives not found!'));
                    }}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

FindLocalRepPopup.propTypes = {
    address: PropTypes.string,
    message: PropTypes.string,
    hideFindRepPopup: PropTypes.func.isRequired,
    isDoubleCheckRepPopup: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    callback: PropTypes.func,
    submitting: PropTypes.bool.isRequired,
    noBack: PropTypes.bool
};

export default FindLocalRepPopup;
